import styled from 'styled-components';
import tw from 'twin.macro';

const StyledBackground = styled.div`
  ${tw`absolute inset-0 z-0 overflow-hidden transform-gpu bg-primary/10`};
`;

const TopLeftGradient = styled.i`
  ${tw`absolute block bg-gradient-radial from-primary via-primary/0 to-primary/0 w-full -left-[45%] -top-[80%] aspect-square rounded-full opacity-30`};
`;

const BottomRightGradient = styled.i`
  ${tw`absolute block bg-gradient-radial from-primary via-primary/0 to-primary/0 w-[75%] -right-[33%] -bottom-[50%] aspect-square rounded-full opacity-20`};
`;

const Background = () => (
  <StyledBackground>
    <TopLeftGradient />
    <BottomRightGradient />
  </StyledBackground>
);

export default Background;
